var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step_container prelative", attrs: { id: _vm.stepData.id } },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "step_header" }, [
        _c("h4", { staticClass: "m-0 semibold" }, [
          _vm._v("\n            " + _vm._s(_vm.stepData.label) + "\n        ")
        ]),
        _vm._v(" "),
        _vm.pagination.total > 0 && _vm.totalPotential
          ? _c("p", { staticClass: "nbOppPipeline mt-1 mb-0 semibold" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.n__(
                      "%(count)s  affaire pour %(potential)s",
                      "%(count)s affaires pour %(potential)s",
                      _vm.pagination.total,
                      {
                        count: _vm.pagination.total,
                        potential: _vm.totalPotential
                      }
                    )
                  ) +
                  "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "mt-1 mb-0 regular" }, [
          _c(
            "a",
            {
              staticClass: "stepAutomationStatus cpointer",
              on: { click: _vm.editAutomation }
            },
            [
              _vm.stepData.automationEnabled == "Y"
                ? _c("span", { staticClass: "gray-60" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Email automatique activé")) +
                        "\n                "
                    )
                  ])
                : _c("span", { staticClass: "gray-60" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Email automatique désactivé")) +
                        "\n                "
                    )
                  ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "container_" + _vm.stepData.id,
          staticClass: "stepCell",
          attrs: { id: "container_" + _vm.stepData.id }
        },
        [
          _c(
            "ul",
            {
              ref: "stepCellList_" + _vm.stepData.id,
              staticClass: "step_content stepCellList"
            },
            [
              _c(
                "SaasDraggable",
                {
                  attrs: {
                    group: "opportunities",
                    useDragArea: true,
                    dragClass: "opportunity-pipeline-card",
                    defaultDragZoneHeight: "340px"
                  },
                  on: { change: _vm.onChangeCallback },
                  model: {
                    value: _vm.oppOrdered,
                    callback: function($$v) {
                      _vm.oppOrdered = $$v
                    },
                    expression: "oppOrdered"
                  }
                },
                _vm._l(_vm.oppOrdered, function(oneOpp) {
                  return _c(
                    "li",
                    {
                      key: oneOpp.id,
                      staticClass:
                        "well well-medium opportunityList mb-2 fs-3 p-0 opportunity-pipeline-card"
                    },
                    [
                      _c("pipeline-card", {
                        ref: "pipelineCard",
                        refInFor: true,
                        attrs: { data: oneOpp, tableDensity: _vm.tableDensity },
                        on: { "handle-context-menu": _vm.handleShowContextMenu }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }